import styles from '../styles.module.css'

type PickerTabItemProps = {
  active: boolean
  icon: React.ReactNode
  label: string
  onClick: () => void
}

export const PickerTabItem: React.FC<PickerTabItemProps> = ({
  active,
  icon,
  label,
  onClick
}) => (
  <button
    type="button"
    role="tab"
    aria-selected={active}
    className={`${styles.modeTab} ${active ? styles.modeTabActive : ''}`}
    onClick={onClick}
  >
    {icon}
    {label}
  </button>
)
